export default __webpack_public_path__ + "b3aaf99a72548044c475141426658c31.png";